import { useNavigate } from "react-router";
import { useGlobalContext } from "app/store/GlobalContext";
import { Button } from "components/button/Button";
import Modal from "components/modal/Modal";

type Props = {
  text?: string;
};

export default function UnsavedChangesModal({ text }: Props) {
  const { redirectingState, setRedirectingState, setEditingState } =
    useGlobalContext();
  const navigate = useNavigate();

  const handleCancelClick = () => {
    setRedirectingState({
      url: "",
      isRedirecting: false,
      clickEvent: undefined,
      shouldHardRedirect: false,
    });
  };

  const handleContinueClick = () => {
    setEditingState({ isEditing: false, location: null });

    if (redirectingState.clickEvent) {
      redirectingState.clickEvent();
    }

    if (redirectingState.shouldHardRedirect && redirectingState.url === "/") {
      window.location.href = redirectingState.url;
    } else {
      navigate(redirectingState.url);
    }

    setRedirectingState({
      url: "",
      isRedirecting: false,
      clickEvent: undefined,
      shouldHardRedirect: false,
    });
  };

  return (
    <Modal
      header={<h1 className="m-0">Ej sparade ändringar</h1>}
      onDismiss={() =>
        setRedirectingState({
          url: "",
          isRedirecting: false,
          clickEvent: undefined,
          shouldHardRedirect: false,
        })
      }
      size="sm"
      modalTitle="unsaved change"
      footer={
        <div className="d-flex align-items-center justify-content-between">
          <Button
            color={"outline"}
            onClick={handleCancelClick}
            className="mr-6"
          >
            Avbryt
          </Button>
          <Button color={"tertiary"} onClick={handleContinueClick}>
            Fortsätt
          </Button>
        </div>
      }
    >
      <div className="modalText">
        <p>
          {text ||
            "Du har ändringar som ej sparats. Är du säker på att du vill lämna sidan?"}
        </p>
      </div>
    </Modal>
  );
}
